import { z } from 'zod';

export const METODOS_PAGAMENTO_VALIDOS = [
  'Dinheiro',
  'Cartão de Crédito',
  'Cartão de Débito',
  'PIX',
  'Transferência',
  'Boleto',
] as const;

export const pagamentoSchema = z.object({
  metodo: z.enum(METODOS_PAGAMENTO_VALIDOS, {
    errorMap: () => ({ message: 'Método de pagamento inválido' }),
  }),
  valor: z.number().positive('O valor do pagamento deve ser maior que zero'),
});

export type PagamentoSchema = z.infer<typeof pagamentoSchema>;
